import { Component, OnInit, Input, ElementRef } from '@angular/core';
import { httpService } from '../service/servicio';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { ViewContainerRef } from '@angular/core';
import { AppComponent } from '../app.component'

@Component({
  selector: 'app-datosmaquinas',
  templateUrl: './datosmaquinas.component.html',
  styleUrls: ['./datosmaquinas.component.css']
})
export class DatosmaquinasComponent implements OnInit {
  visitas: any[];
  diasVisitas = ['L', 'M', 'X', 'J', 'V', 'L', 'M', 'X', 'J', 'V']


  constructor(public http:httpService,  public app:AppComponent, public toastr: ToastsManager, vcr: ViewContainerRef, private elem: ElementRef) {

      this.toastr.setRootViewContainerRef(app.vcr);

      if (this.http.maquinaGrabar.Id == 0)  this.tituloMaquina = "Nueva Máquina";


      this.descargarMarcas();

   }

  ngOnInit() {
  }


  @Input() marcas:any;
  @Input() modelos:any;
  @Input() posiciones:any;
  @Input() clientes:any;
  @Input() docs:any;


    xServicio:any = [

      { Id:0, Valor:'NO' },
      { Id:1, Valor:'SI' }

    ]


  tituloMaquina:string = 'Editando Maquina número: ' + this.http.maquinaGrabar.Id;

  clienteactual:any;
  posicionactual:any;
  mostrarDoc:boolean = false;
  mostrarUpload:boolean =false;
  nomfich:string = '';
  ficheroBorrar:string ='';

  loaded:boolean = false;
  cloaded:number = 0;

  muestraVisita: boolean = false;


  volver() {
    this.http.sw.mostrarDatosmaquinas = false;
    this.http.sw.mostrarMenu = true;
    this.http.sw.mostrarTarifas = false;
    this.http.sw.mostrarMaquinas = true;
  }

  volverDocs() {

    this.mostrarUpload = false;
    this.mostrarDoc =false;

  }



    uploadFile() {

      let files = this.elem.nativeElement.querySelector('#selectFile').files;
      let formData = new FormData();
      let file = files[0];



      formData.append('selectFile', file, file.name);
      formData.append('path', this.http.maquinaGrabar.Id);


      this.http.uploadFile(formData).subscribe( uploaded => {

        this.http.uploaded = uploaded;
        if (this.http.uploaded.Status == 1) {
          this.toastr.success(this.http.uploaded.Text,'Subida de Ficheros');

          this.documentos(this.http.maquinaGrabar.Id);

        }else{
          this.toastr.error(this.http.uploaded.Text,'Subida de Ficheros');
        }

      });


    }

    borrarfichero() {

      this.http.deleteFile(this.http.maquinaGrabar.Id, this.ficheroBorrar).subscribe(respuesta => {

      this.http.uploaded = respuesta;


      }, err => {

       (err.message);
      }, () => {

        if (this.http.uploaded.Status == 1) {
           this.toastr.success(this.http.uploaded.Text,'Base de Datos');
           this.documentos(this.http.maquinaGrabar.Id);

         }else{
           this.toastr.error(this.http.uploaded.Text,'Base de Datos');
        }
      });

    }



    selFichero(fichero) {

      this.ficheroBorrar = fichero;

    }

    documentos(Id) {

      this.nomfich = 'https://www.grupovalenzuela.com/Duran/php/Documentos/' + this.http.maquinaGrabar.Id + '/';

      this.http.descargarDocs(Id).subscribe(doc => {

      this.docs = doc;

      }, err => {

    }, () => {

          this.mostrarUpload = false;
          this.mostrarDoc =true;

      });


    }

    filtrodoc() {

      if (this.docs) {

        return this.docs.filter((doc) => {

           return (doc != '.' && doc!='..');
         });
      }else{

        return this.docs;
      }

    }


  borrar(){

      this.http.datosPost.action = 2; // borrar maquina
      this.http.datosPost.datos = this.http.maquinaGrabar;
      this.http.maquina(this.http.datosPost).subscribe(respuesta => {
            this.http.uploaded = respuesta;

        }, err => {

        }, () => {
            if (this.http.uploaded.Status == 1) {
                  this.toastr.success(this.http.uploaded.Text, 'Máquinas');
                  this.http.descargarMaquinas(0).subscribe(respuesta => {
                  this.http.sw.mostrarDatosmaquinas = false;
                  this.http.sw.mostrarMenu = true;
                  this.http.sw.mostrarMaquinas = true;
                });
            }else{
                this.toastr.error(this.http.uploaded.Text,'Maquinas');
            }
      });

  }

  cambiaVisita(visita) {
    console.log('checkvisita: ', visita)
    this.visitas[visita.index].valor = visita.valor;
    visita.valor = !visita.valor
    console.log(this.visitas);
    
  }

  grabarVisitas() {
    let vi = '';
    for (let i = 0; i < 10; i++) {
      let c = (this.visitas[i].valor) ? 'V' : 'F'
      vi = vi + c;
    }
    this.http.maquinaGrabar.visitas = vi;
    this.grabar();
  }

  grabar() {
  this.http.datosPost.action = 1; // por defecto Update
  if (this.http.maquinaGrabar.Id == 0) this.http.datosPost.action = 0; // si es nueva Insert;
    this.http.maquinaGrabar.observaciones.replace(/\r?\n/g, "$");
    this.http.datosPost.datos = this.http.maquinaGrabar;
    this.http.maquina(this.http.datosPost).subscribe(respuesta => {
          this.http.uploaded = respuesta;

      }, err => {

      }, () => {
          if (this.http.uploaded.Status == 1) {
              this.toastr.success(this.http.uploaded.Text,'Maquinas');
              this.http.descargarMaquinas(0).subscribe(respuesta => {
                this.http.sw.mostrarMenu = true;
                this.http.sw.mostrarMaquinas = true;
                this.http.sw.mostrarDatosmaquinas = false;

              });
          }else{
              this.toastr.error(this.http.uploaded.Text,'Maquinas');
          }
    });

  }


  filtroposiciones() {
    return this.posiciones.filter((posicion) => {
          return posicion.cliente == this.clienteactual.Id });
  }

  visita() {
    console.log('en visita')
    let vis = this.http.maquinaGrabar.visitas;
    this.visitas = [  
      { index: 0, dia: 'L', valor: vis[0] === 'V' },
      { index: 1, dia: 'M', valor: vis[1] === 'V'},
      { index: 2, dia: 'X', valor: vis[2] === 'V'},
      { index: 3, dia: 'J', valor: vis[3] === 'V'},
      { index: 4, dia: 'V', valor: vis[4] === 'V'},
      { index: 5, dia: 'L', valor: vis[5] === 'V'},
      { index: 6, dia: 'M', valor: vis[6] === 'V'},
      { index: 7, dia: 'X', valor: vis[7] === 'V'},
      { index: 8, dia: 'J', valor: vis[8] === 'V'},
      { index: 9, dia: 'V', valor: vis[9] === 'V'},
    ]
    
    this.muestraVisita = true;
    
  }

  descargarPosiciones() {
              this.loaded = false;
              this.http.descargarPosiciones()
              .subscribe(posicion => {
                   this.posiciones = posicion;
                   this.posicionactual = this.posiciones.find(posicion => posicion.Id === this.http.maquinaGrabar.posicion);
                   
              }, err => {
                 (err.message);
              }, () => {
                if ( (this.http.maquinaGrabar.Id == 0) || (this.posicionactual == null) ) {
                  //this.http.maquinaGrabar.cliente = this.clientes[0].Id;
                  this.http.maquinaGrabar.marca = this.marcas[0].Id;
                  this.http.maquinaGrabar.modelo = this.modelos[0].Id;
                  this.http.maquinaGrabar.posicion = this.posiciones[0].Id;
                  this.posicionactual = this.posiciones[0];
                  this.selCliente(this.clientes[0].Id);

                }

                    this.posicionactual = this.posiciones.find(posicion => posicion.Id === this.http.maquinaGrabar.posicion);

                    this.clienteactual =  this.clientes.find(cliente => cliente.Id ===  this.posicionactual.cliente);
                    this.loaded=true;


                    this.loaded = true;
                    this.http.sw.mostrarMaquinas = false;
                    this.http.sw.mostrarMenu = false;
                    this.http.sw.mostrarTarifas = false;

              });
    }


    descargarClientes() {

                this.http.descargarClientes()
                .subscribe(cliente => {
                     this.clientes = cliente;

                }, err => {

                }, () => {

                  this.descargarPosiciones();
                });
      }

    descargarMarcas() {

                this.http.descargarMarcas()
                .subscribe(marca => {
                     this.marcas = marca;

                }, err => {

                }, () => {

                  this.descargarModelos()
                });
      }

    descargarModelos() {

                  this.http.descargarModelos()
                  .subscribe(modelo => {
                       this.modelos = modelo;

                  }, err => {

                  }, () => {

                    this.descargarClientes();
                  });
        }

    selMarca(Id) {
        this.http.maquinaGrabar.marca = Id;

      }

    selValor(Id) {
          this.http.maquinaGrabar.porservicio = Id;

        }

    selModelo(Id) {
        this.http.maquinaGrabar.modelo = Id;

      }

    selPosicion(Id) {
        this.http.maquinaGrabar.posicion = Id;

    }

    selCliente(Id) {
        this.clienteactual =  this.clientes.find(cliente => cliente.Id ===  Id);
        this.posicionactual = this.posiciones.find(posicion => posicion.cliente === Id);
        if (!this.posicionactual) this.posicionactual = this.posiciones[0]
        this.filtroposiciones();
        this.http.maquinaGrabar.posicion = this.posicionactual.Id;

    }

    tarifas() {

       this.http.tarifaGrabar = this.http.nuevaTarifa();
       
       this.http.sw.mostrarDatosmaquinas = false;
       this.http.sw.mostrarTarifas = true;


    }

}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/datosmaquinas/datosmaquinas.component.ts